<template>
  <div class="index">
    <div class="index-login">
      <!-- pc -->
      <el-carousel v-if="isMobile != '1'" height="700px">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <el-image
            class="image"
            :src="URL + item.sourceUrl"
            fit="fill"
          ></el-image>
        </el-carousel-item>
      </el-carousel>
      <!-- mobile -->
      <van-swipe v-else indicator-color="white">
        <van-swipe-item v-for="item in bannerList" :key="item.id">
          <el-image
            class="image"
            :src="URL + item.sourceUrl"
            fit="fill"
          ></el-image>
        </van-swipe-item>
      </van-swipe>
      <div class="friend-link">
        <div class="link">
          <img src="@/assets/hpdiv1title.png" alt="" />
        </div>
        <div
          class="link"
          v-for="item in friendList"
          :key="item.id"
          @click="linkPush(item)"
        >
          <img
            :src="URL + item.friendImage"
            :alt="item.name"
            :title="item.name"
          />
        </div>
      </div>
    </div>
    <el-collapse-transition>
      <router-view v-show="$route.path !== '/'"></router-view>
    </el-collapse-transition>
  </div>
</template>
<script>
// import tabbar from "@/components/tabbar.vue";
import { sysBannerList } from "../../util/banner/banner";
import { sysFriendLinkList } from "../../util/friendlink/friendlink";
import { URL } from "../../util/config.js";
import { sysNewsList } from "../../util/news/news.js";
import { searchwebConfig } from "../../util/set/set.js";
export default {
  inject: ["reload"],
  data() {
    return {
      name: localStorage.getItem("name"),
      URL: URL,
      isRegister: false,
      form: {
        idCardNo: "",
        passWord: "",
        code: "",
      },
      resform: {
        idCardNo: "",
        name: "",
        mobile: "",
        sex: "",
      },
      codeList: [],
      codeData: "", //code值
      // codeValue: "", //输入的code
      moduleList: [], //业务介绍列表
      noticeOne: "",
      noticeList: [], //开班预告列表
      ruleList: [], //政策法规列表
      uploadList: [], //资料下载列表
      recommendList: [], //推荐课程列表
      clickId: 1, //1.开班预告 2.政策法规
      isMobile: sessionStorage.getItem("isMobile"),
      ywCode: "", //业务介绍code
      kbCode: "", //开班预告code
      zcCode: "", //政策法规code
      zlCode: "", //资料下载code
      tjCode: "", //推荐课程code
      pwdDis: false,
      activeStep: 0,
      pwdParams: {
        userName: "",
        idCardNo: "",
        pwd: "",
        confirm: "",
      },
      rules: {
        pwd: [
          { min: 6, max: 12, message: "长度在6到12个字符", trigger: "blur" },
        ],
        confirm: [
          { min: 6, max: 12, message: "长度在6到12个字符", trigger: "blur" },
        ],
      },
      navListCount: 0, // 监听navlist改变状态 1则已获取
      bannerList: [],
      friendList: [],
      setInfo: {},
    };
  },
  components: {},
  created() {
    sysBannerList().then((res) => {
      // console.log(res.data);
      this.bannerList = res.data;
    });

    searchwebConfig().then((res) => {
      this.setInfo = res.data;
    });
    // linkFlag == 0 ? 主页友情链接 : 头部跳转链接
    sysFriendLinkList({ linkFlag: 0 }).then((res) => {
      this.friendList = res.data;
    });
  },
  mounted() {},
  computed: {
    DealTime() {
      return (time) => {
        return time.split(" ")[0];
      };
    },
  },
  methods: {
    getStyle(data) {
      return `color: ${data.color}; font-size: ${data.fontSize}; padding: ${data.padding}; transform: ${data.transform}`;
    },
    //获取相对应的新闻列表
    getList(code, name, val) {
      let params;
      let that = this;
      if (val === "nav") {
        params = {
          pageIndex: 1,
          pageSize: 10,
          newsCode: code,
        };
      } else {
        params = {
          pageIndex: 1,
          pageSize: 4,
          typeCode: code,
        };
      }
      sysNewsList(params).then((res) => {
        // console.log(res);
        if (res.code === 0) {
          if (name === "业务介绍") {
            that.moduleList = res.data.list;
          } else if (name === "开班预告") {
            that.noticeOne = [...res.data.list][0];
            that.noticeList = [...res.data.list].splice(1, 3);
          } else if (name === "政策法规") {
            that.ruleList = [...res.data.list].splice(0, 6);
          } else if (name === "资料下载") {
            that.uploadList = res.data.list.splice(0, 6);
          } else if (name === "推荐课程") {
            that.recommendList = res.data.list;
          }
        }
      });
    },
    linkPush(item) {
      window.open(item.hrefUrl);
    },
  },
};
</script>
<style lang="scss">
@import "../../style/color.scss";
@function pxToRem($args) {
  @return $args / 50 + rem;
}

.index {
  // overflow-y: scroll;

  .adversite {
    width: 100%;
    height: 150px;
    display: block;
    &:hover {
      cursor: pointer;
    }
  }
  .form-box {
    width: 50%;
    margin: 30px auto 0;
    .el-input {
      width: auto;
    }
  }
  .el-form-item__label {
    white-space: nowrap;
  }

  .ValidCode {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    float: right;
    line-height: 40px;
    span {
      display: inline-block;
    }
  }
  .index-login {
    position: relative;

    .image {
      display: block;
    }

    .el-carousel__arrow {
      width: 90px;
      height: 90px;
    }
    .el-carousel__arrow--left {
      left: 100px;
    }
    .el-carousel__arrow--right {
      right: 100px;
    }
    .el-icon-arrow-left,
    .el-icon-arrow-right {
      font-size: 20px;
    }

    .el-carousel__container {
      height: 400px;
    }

    .el-image {
      width: 100%;
      height: 100%;
    }
    .index-login-card {
      width: 284px;
      // height: 90%;
      position: absolute;
      right: 230px;
      top: 4%;
      background-color: #efeff0;
      border-radius: 5px;
      z-index: 10;
      .index-login-card-top {
        height: 40px;
        line-height: 40px;
        background-color: #589afd;
        color: $white;
        padding: 0 20px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        img {
          margin-right: 5px;
        }
        .user_icon {
          vertical-align: text-top;
        }
        .user-register {
          float: right;
          font-size: 14px;
          cursor: pointer;
          &:hover {
            color: #2b74e2;
            font-weight: bold;
          }
        }
      }

      .el-input__inner {
        height: 35px !important;
      }

      .index-login-card-content {
        padding: 10px 20px;
        font-size: 14px;
        .index-login-card-content-item {
          margin-bottom: 15px;

          p {
            font-size: 13px;
            margin-bottom: 2px;
          }
          .forget {
            float: right;
            color: #4087f2;
            font-size: 12px;
            // line-height: 28px;
            cursor: pointer;
            &:hover {
              color: #2b74e2;
            }
          }
          .login-codeimg {
            width: 35%;
            margin-left: 5%;
            height: 40px;
            float: right;
            cursor: pointer;
          }
        }
        .index-login-card-btn {
          background-color: $blue;
          color: $white;
          width: 100%;
          height: 37px;
          line-height: 37px;
          text-align: center;
          cursor: pointer;
          &:hover {
            background-color: #2b74e2;
          }
        }
      }
    }
    .friend-link {
      width: 100%;
      height: 400px;
      background-image: url("../../assets/hpdiv1bg.jpeg");
      display: flex;
      justify-content: center;
      align-items: center;

      .link {
        width: 273px;
        height: 221px;
        // background-color: #fff;
        margin-right: 30px;
        position: relative;
        &:hover {
          cursor: pointer;
        }
        &:first-child {
          background-color: transparent;
          &:hover {
            cursor: auto;
          }
        }

        img {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
  .index-module {
    width: 1200px;
    padding: 0 0 50px 0;
    margin: 0 auto;
    background-color: $white;
    .index-module-title {
      text-align: center;
      font-size: 30px;
      color: $blue;
      font-family: Microsoft YaHei;
      padding: 60px 0;
      img {
        margin-top: 7px;
        vertical-align: top;
      }
      .modulep {
        color: #b9b9b9;
        font-size: 14px;
        position: relative;
      }
      .showmore {
        position: absolute;
        right: 0;
        cursor: pointer;
        color: #999999;
        &:hover {
          color: $blue;
        }
      }
    }
    .index-module-content {
      .index-module-content-item {
        width: calc(25% - 20px);
        // height: 320px;
        display: inline-block;
        margin-right: 24px;
        border: 1px solid #ececec;
        box-shadow: 2px 5px 5px 0px rgba(236, 235, 235, 0.3);
        &:last-child {
          margin-right: 0;
        }
        img {
          transition: all 0.3s;
          &:hover {
            transform: scale(1.1);
          }
        }
        .index-module-content-title {
          margin-top: 5px;
          font-size: 18px;
          font-weight: bold;
          height: 30px;
          line-height: 30px;
          color: $default;
          text-align: center;
        }
        .index-module-content-tip {
          width: calc(100% - 20px);
          margin: 5px 10px 20px 10px;
          font-size: 14px;
          height: 20px;
          color: #8e8e8e;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .index-module-btn {
          width: calc(100% - 20px);
          margin: 0 10px 15px 10px;
          line-height: 38px;
          text-align: center;
          cursor: pointer;
          color: $blue;
          font-size: 16px;
          border: 1px solid #4087f2;
          border-radius: 5px;
          transition: all 0.3s;
          &:hover {
            color: $white;
            background-color: $blue;
          }
        }
      }
    }
  }
  .index-block {
    width: 1200px;
    padding: 50px 0;
    margin: 0 auto;
    height: 340px;
    .index-block-title {
      color: $blue;
      font-size: 26px;
      position: relative;
      margin-bottom: 20px;
      img {
        margin-top: 6px;
        vertical-align: top;
      }
      .showmore {
        position: absolute;
        right: 0;
        bottom: 5px;
        cursor: pointer;
        color: #999999;
        font-size: 14px;
        &:hover {
          color: $blue;
        }
      }
    }
    .title {
      width: 73%;
      color: #666666;
      font-size: 14px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 1%;
    }
    .create {
      // width: 26%;
      font-size: 14px;
      display: inline-block;
      color: #aeaeae;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .description {
      font-size: 14px;
      color: #8e8e8e;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .index-block-long {
      width: calc((100% / 3) * 2 - 40px);
      display: inline-block;
      .index-block-long-img {
        display: inline-block;
        width: 326px;
        height: 100%;
        position: relative;
        cursor: pointer;
        img {
          transition: all 0.3s;
        }
        &:hover {
          img {
            transform: scale(1.1);
          }
        }
        p {
          width: calc(100% - 40px);
          padding: 0 20px;
          height: 40px;
          line-height: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: $white;
          font-size: 16px;
          background-color: rgba(51, 51, 51, 0.5);
          position: absolute;
          bottom: 0;
        }
      }
      .index-block-long-list {
        width: calc(100% - 375px);
        display: inline-block;
        vertical-align: top;
        height: 270px;
        margin: 10px 0;
        padding: 0 20px;
        overflow: hidden;
        .index-block-long-listitem {
          height: calc((100% / 4) - 20px);
          cursor: pointer;
          padding: 10px;
          &:hover {
            background-color: #fff;
            box-shadow: 2px 5px 5px 0px rgba(236, 235, 235, 0.3);
          }
        }
      }
      .index-block-long-imglist {
        width: calc(100% - 40px);
        height: 233px;
        padding: 30px 20px;
        .index-block-long-imglistitem {
          width: calc((100% / 2) - 25px);
          cursor: pointer;
          height: 47.5%;
          margin-bottom: 2.5%;
          // padding: 10px 0;
          margin-right: 50px;
          display: inline-block;
          vertical-align: top;
          &:nth-child(even) {
            margin: 0;
          }
          .index-block-imglist-content {
            display: inline-block;
            width: calc(50% - 10px);
            margin-left: 5px;
            vertical-align: top;
            position: relative;
            height: 100%;
            p {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .index-block-imglist-content-tag {
              position: absolute;
              bottom: 0;
              background: #8cbafe;
              border-radius: 10px;
              line-height: 20px;
              padding: 0 10px;
              font-size: 13px;
              color: $white;
            }
          }
          img {
            transition: all 0.3s;
          }
          &:hover {
            img {
              transform: scale(1.1);
            }
          }
        }
      }
    }
    .index-block-short {
      width: calc(100% / 3);
      display: inline-block;
      vertical-align: top;
      margin-left: 35px;
      .index-block-short-list {
        width: 100%;
        display: inline-block;
        vertical-align: top;
        height: 289px;
        padding: 20px 0;
        box-sizing: border-box;
        border: 1px solid #e1e1e1;
        overflow: hidden;
        .index-block-short-listitem {
          height: calc((100% / 7) - 10px);
          margin: 5px 0 10px 0;
          padding: 0 15px;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          &:last-child {
            margin-bottom: 0;
          }
          &:hover {
            background-color: #fff;
            box-shadow: 2px 5px 5px 0px rgba(236, 235, 235, 0.7);
          }
        }
      }
    }
  }
  .index-m-block {
    display: none;
  }
}
@media (max-width: 1024px) {
  // .index-login {
  //   display: none;
  // }
  .index {
    .index-login {
      .friend-link {
        height: auto;
        display: block;

        .link {
          width: 100%;
          height: pxToRem(180);
          &::after {
            content: "";
            display: block;
            background-color: #f8f8f8;
            width: 100%;
            height: pxToRem(10);
          }

          &:first-child {
            height: pxToRem(100);

            img {
              height: pxToRem(50);
            }
          }
        }
      }
    }
  }

  .index-module {
    width: calc(100% - 40px) !important;
    padding: 0 20px 50px 20px !important;
    background-color: #fafafb !important;
    .index-module-title {
      padding: 15px 0 !important;
      font-size: 16px !important;
      .modulep {
        font-size: 10px !important;
      }
      .showmore {
        display: none;
      }
      img {
        width: 13px !important;
        height: 15px !important;
        margin-top: 4px !important;
      }
    }
    .index-module-content {
      .index-module-content-item {
        width: calc(50% - 7px) !important;
        height: auto !important;
        display: inline-block;
        margin: 0 10px 10px 0 !important;
        border: 1px solid #ececec;
        box-shadow: 2px 5px 5px 0px rgba(236, 235, 235, 0.3);
        &:nth-child(even) {
          margin: 0 !important;
        }
        img {
          height: 27vw;
        }
        .index-module-content-title {
          margin-top: 5px;
          font-size: 14px !important;
          font-weight: bold;
          height: 20px !important;
          line-height: 20px !important;
          color: $default;
          text-align: center;
        }
        .index-module-content-tip {
          width: calc(100% - 20px);
          margin: 5px 10px 10px 10px !important;
          font-size: 12px !important;
          height: 20px;
          color: #8e8e8e;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .index-module-btn {
          width: calc(100% - 20px);
          margin: 0 10px 10px 10px !important;
          line-height: 20px !important;
          text-align: center;
          cursor: pointer;
          color: $white !important;
          background-color: $blue;
          font-size: 12px !important;
          border: none;
          border-radius: 5px;
          &:active {
            opacity: 0.7;
          }
        }
      }
    }
  }
  .index-block {
    display: none;
  }
  .index-m-block {
    display: block !important;
    .index-m-block-title {
      color: $blue;
      font-size: 16px;
      padding: 10px 0;
      img {
        width: 15px;
        height: 15px;
        margin-top: 4px;
        vertical-align: top;
      }
    }
    .index-m-block-tab {
      height: 40px;
      .index-m-block-tab-item {
        width: 50%;
        float: left;
        .index-block-title {
          line-height: 40px;
          font-size: 16px;
          text-align: center;
          background-color: #fafafb;
          color: #888888;
          img {
            width: 15px;
            height: 15px;
            margin-top: 11px;
            vertical-align: top;
          }
        }
        .active {
          background-color: $white;
          color: $blue;
        }
      }
    }
    .index-m-block-content {
      width: calc(100% - 40px);
      padding: 30px 20px 0 20px;
      .index-block-short-list {
        width: calc((100% / 3) - 5px);
        height: auto;
        display: inline-block;
        margin: 0 6px 10px 0;
        background-color: #f3f3f3;
        box-shadow: 2px 5px 5px 0px rgba(236, 235, 235, 0.3);
        &:nth-child(3n + 1) {
          margin: 0 !important;
        }
        .file-iconimg {
          width: 30px;
          height: 23px;
          position: relative;
          left: 50%;
          transform: translateX(-50%);
          margin: 15px 0 5px 0;
        }
        .title {
          width: 100%;
          // padding: 0 5%;
          text-align: center;
          color: #666666;
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: normal;
        }
        .create {
          width: 90%;
          font-size: 12px;
          padding: 0 5%;
          text-align: center;
        }
      }
      .index-block-long-img {
        width: 100%;
        // height: 200px;
        position: relative;
        p {
          width: calc(100% - 20px);
          padding: 0 10px;
          height: 30px;
          line-height: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: $white;
          font-size: 10px;
          background-color: rgba(51, 51, 51, 0.5);
          position: absolute;
          bottom: 0;
        }
      }
      .index-block-long-listitem {
        padding: 20px 0;
        border-bottom: 1px dashed #e3e3e3;
      }
      .title {
        width: 67%;
        color: #666666;
        font-size: 14px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 1%;
      }
      .create {
        // width: 30%;
        font-size: 10px;
        display: inline-block;
        color: #aeaeae;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .description {
        font-size: 10px;
        color: #8e8e8e;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .index-block-m-btn {
        line-height: 30px;
        text-align: center;
        width: 100%;
        border: 1px solid $blue;
        margin: 10px 0;
        font-size: 14px;
        color: $blue;
        &:active {
          opacity: 0.7;
        }
      }
      .index-block-long-imglist {
        width: 100%;
        // height: 233px;
        // padding: 10px 0;
        .index-block-long-imglistitem {
          width: 100%;
          height: 90px;
          margin-bottom: 2.5%;
          position: relative;
          // padding: 10px 0;
          // margin-right: 50px;
          // display: inline-block;
          // vertical-align: top;
          .index-block-imglist-content {
            width: calc(50% - 15px);
            margin-left: 15px;
            float: right;
            font-size: 14px;
          }
          .index-block-imglist-content-tag {
            position: absolute;
            bottom: 0;
            background: #8cbafe;
            border-radius: 10px;
            line-height: 20px;
            padding: 0 10px;
            font-size: 13px;
            color: $white;
          }
        }
      }
    }
  }
}
</style>
